import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import { useEffect } from 'react';

import Donation from "../../components/Donation";
import { gtag } from '../..';
import "./About.css";

const About = () => {
    useEffect(() => {
        gtag('event', 'page_view', {
            page_title: 'About',
            page_path: '/about'
        });
    });

    return (
        <div className="about">
            <Typography component="h1" variant="h1">
                About Scrum Poker
            </Typography>
            <Card>
                <CardContent className='summary-content'>
                    <Typography component="h2" variant="h2">
                        Why This Tool Exists
                    </Typography>
                    <Typography component="p" variant="p">
                        Scrum Poker was built out of a simple need: a free, lightweight <a href="/what-is-planning-poker">Planning Poker</a> tool that works instantly in the browser with no sign-ups, no installations, and no feature bloat. Create a room, share the link, and start estimating. That's it.
                    </Typography>
                    <Typography component="p" variant="p">
                        Most existing tools either require paid accounts, force you through onboarding flows, or bury the estimation behind project management features you don't need. Scrum Poker focuses on doing one thing well: helping agile teams estimate together in real time.
                    </Typography>

                    <Typography component="h2" variant="h2">
                        How It's Built
                    </Typography>
                    <Typography component="p" variant="p">
                        The tool runs entirely on AWS serverless infrastructure: WebSocket API Gateway for real-time communication, Lambda functions for the backend logic, DynamoDB for temporary room state, and CloudFront + S3 for the frontend. This architecture keeps costs low and latency minimal, regardless of where your team is located.
                    </Typography>
                    <Typography component="p" variant="p">
                        The frontend is built with React and uses WebSockets to synchronize card selections across all participants in real time. When everyone has voted, the results are revealed simultaneously to avoid <a href="/estimation-best-practices">anchoring bias</a>.
                    </Typography>

                    <Typography component="h2" variant="h2">
                        About the Creator
                    </Typography>
                    <Typography component="p" variant="p">
                        <a href="https://www.linkedin.com/in/freddybrasileiro/" target="_blank" rel="noreferrer">Freddy Brasileiro</a> is a Software Engineering Manager with 6+ years leading teams across fintech, payments, and marketplace — from early-stage startups to Latin America's most valuable tech company. He holds a BSc and MSc in Computer Science from UFES (Brazil), and an MBA in Strategic Leadership and People Management from FIA Business School.
                    </Typography>
                    <Typography component="p" variant="p">
                        At <strong>Clutch</strong>, Freddy leads a 12-person Account Opening team building the digital onboarding platform for US credit unions — replacing legacy 45-minute branch workflows with a system that has cut fraud by 90% and tripled account opening rates. At <strong>Mercado Libre</strong> (4.5 years), he managed teams across three countries and three business units: scaling B2B Marketplace engineering from 8 to 48 people, owning the Payment Gateway that processed every card transaction for Mercado Libre and Mercado Pago, and building the Checkout CRO practice from zero with dedicated data engineers and A/B testing infrastructure.
                    </Typography>
                    <Typography component="p" variant="p">
                        At <strong>Guiabolso</strong>, he grew from senior frontend engineer to Head of Engineering in under two years — reporting to the CEO, leading ~20 engineers, and building Guiabolso Connect, a B2B Open Banking product that pioneered the space in Brazil before regulation mandated it. He also led the sale and infrastructure migration of JustOnline to Banco Votorantim.
                    </Typography>
                    <Typography component="p" variant="p">
                        Earlier, Freddy co-founded <strong>Menthor</strong>, applying semantic web research to a real product — cutting Globosat's video tagging time by 50% using ontology-driven automation. His academic work includes published research at the World Wide Web Conference (WWW) and the International Semantic Web Conference (ISWC), plus five years of R&D projects and teaching Computer Science at university level. His <a href="https://scholar.google.com/citations?user=3oACh4AAAAAJ&hl=pt-PT" target="_blank" rel="noreferrer">publications are on Google Scholar</a>.
                    </Typography>
                    <Typography component="p" variant="p">
                        Scrum Poker started as a side project to scratch his own itch during sprint plannings and to explore AWS serverless technologies. It has since grown into a tool used by thousands of teams around the world.
                    </Typography>

                    <Typography component="h2" variant="h2">
                        Support the Project
                    </Typography>
                    <Typography component="p" variant="p">
                        Scrum Poker is free to use and will stay that way. The AWS infrastructure has running costs, though, so if you find the tool useful, consider supporting it:
                    </Typography>
                    <Donation />
                </CardContent>
            </Card>
        </div>
    );
}

export default About;
